import React from 'react';

import Tools from '../../components/Tools/Tools';
import OurAuditorium from './OurAuditorium/OurAuditorium';
import CoursePackets from '../../components/CoursePackets/CoursePackets';
import FreeConsultation from '../../components/FreeConsultation/FreeConsultation';
import { useScrollToTopOnMount } from '../../hooks/useScrollToTopOnMount';
import { sectionIds } from '../../utils/constants';
import { PagesEnum } from '../../utils/enums';
import { useAccessibility } from '../../contexts/AccessibilityContext';

const Courses = () => {
  useScrollToTopOnMount();
  const {
    settings: { theme },
  } = useAccessibility();

  return (
    <main className='page'>
      <OurAuditorium id={sectionIds[PagesEnum.Courses].ourAuditorium} />
      <Tools id={sectionIds[PagesEnum.Courses].tools} theme={theme} />
      <CoursePackets id={sectionIds[PagesEnum.Courses].coursePackets} />
      <FreeConsultation
        id={sectionIds[PagesEnum.Courses].consultation}
        title='НАЧНИ ПРЯМО СЕЙЧАС'
        subTitle='ЗАПИШИСЬ НА БЕСПЛАТНУЮ КОНСУЛЬТАЦИЮ'
        description='Найди точки своего роста и составь пошаговый план увеличения дохода вместе с нашим экспертом'
      />
    </main>
  );
};

export default Courses;
